<app-auth-shell [wide]="true">
  <div auth-intro>
    <h1 class="auth-headline auth-reveal" style="--i: 1">
      Kostenloser Zugang für<br><span class="auth-accent">Hausverwaltungen.</span>
    </h1>
    <p class="auth-lead auth-reveal" style="--i: 2">
      Wenn Sie als Hausverwaltung mit Ihren Hausmeistern zusammenarbeiten möchten, können Sie Ihre Hausverwaltung hier
      <strong>kostenlos</strong> registrieren. Nach einer individuellen Überprüfung Ihrer Daten erhalten Sie Ihre
      Zugangsdaten per E-Mail.
    </p>
    <div class="auth-features auth-reveal" style="--i: 3">
      <span class="auth-feature"><i nz-icon nzType="check-circle"></i>Kostenlos</span>
      <span class="auth-feature"><i nz-icon nzType="check-circle"></i>Zusammenarbeit mit Ihrem Hausmeisterdienst</span>
      <span class="auth-feature"><i nz-icon nzType="check-circle"></i>Persönlicher Zugang</span>
    </div>
    <p class="auth-lead auth-reveal" style="--i: 4">
      Sie sind Hausmeister oder ein Unternehmen? <a routerLink="/application">Hier geht es zur Registrierung für
      Hausmeister.</a>
    </p>
  </div>

  <h2 class="auth-card-title">Hausverwaltung registrieren</h2>
  <p class="auth-card-subtitle">Kostenloser Account für Hausverwaltungen</p>

  <form nz-form nzLayout="vertical" [formGroup]="signUpForm" class="login-form" (ngSubmit)="submitForm()">
    <p class="auth-card-section">Angaben zur Hausverwaltung</p>
    <div nz-row [nzGutter]="12">
      <nz-form-item nz-col nzSpan="24">
        <nz-form-label nzRequired nzFor="company">Name der Hausverwaltung</nz-form-label>
        <nz-form-control>
          <input type="text" nz-input formControlName="company_name" placeholder="Hausverwaltung Mustermann"
                 id="company">
        </nz-form-control>
      </nz-form-item>
      <nz-form-item nz-col nzSpan="24">
        <nz-form-label nzRequired nzFor="address">Adresse</nz-form-label>
        <nz-form-control>
          <input formControlName="address" nz-input placeholder="Musterstraße 7a" id="address">
        </nz-form-control>
      </nz-form-item>
      <nz-form-item nz-col [nzXs]="24" [nzSm]="6">
        <nz-form-label nzRequired nzFor="zip">PLZ</nz-form-label>
        <nz-form-control>
          <input formControlName="zip" nz-input placeholder="PLZ" id="zip">
        </nz-form-control>
      </nz-form-item>
      <nz-form-item nz-col [nzXs]="24" [nzSm]="9">
        <nz-form-label nzRequired nzFor="city">Ort</nz-form-label>
        <nz-form-control>
          <input formControlName="city" nz-input placeholder="Ort" id="city">
        </nz-form-control>
      </nz-form-item>
      <nz-form-item nz-col [nzXs]="24" [nzSm]="9">
        <nz-form-label nzFor="country" nzRequired>Land</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="country" nzId="country">
            @for (country of countryService.countries; track country) {
              <nz-option [nzValue]="country.code" [nzLabel]="country.name"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <p class="auth-card-section">Ansprechpartner</p>
    <div nz-row [nzGutter]="12">
      <nz-form-item nz-col [nzXs]="24" [nzSm]="12">
        <nz-form-label nzRequired nzFor="firstname">Vorname</nz-form-label>
        <nz-form-control>
          <input type="text" nz-input formControlName="firstname" placeholder="Max" id="firstname">
        </nz-form-control>
      </nz-form-item>
      <nz-form-item nz-col [nzXs]="24" [nzSm]="12">
        <nz-form-label nzRequired nzFor="lastname">Nachname</nz-form-label>
        <nz-form-control>
          <input type="text" nz-input formControlName="lastname" placeholder="Mustermann" id="lastname">
        </nz-form-control>
      </nz-form-item>
      <nz-form-item nz-col [nzXs]="24" [nzSm]="12">
        <nz-form-label nzRequired nzFor="email">E-Mailadresse</nz-form-label>
        <nz-form-control>
          <input type="text" nz-input formControlName="email"
                 placeholder="mustermann@hausverwaltung-mustermann.de" id="email">
        </nz-form-control>
      </nz-form-item>
      <nz-form-item nz-col [nzXs]="24" [nzSm]="12">
        <nz-form-label nzRequired nzFor="phone">Telefonnummer für Rückfragen</nz-form-label>
        <nz-form-control>
          <input type="text" nz-input formControlName="phone" placeholder="+49 1234 123456" id="phone">
        </nz-form-control>
      </nz-form-item>
    </div>

    <nz-form-item>
      <label nz-checkbox formControlName="privacy">
        Ich willige ein, dass meine Angaben gespeichert werden, um mit mir in Kontakt treten zu dürfen. Ich habe die
        <a href="https://hausmeisterapp.com/datenschutz/" target="_blank">Datenschutzerklärung</a> gelesen und stimme
        dieser zu.
      </label>
    </nz-form-item>

    <button nz-button class="auth-submit" [nzLoading]="disabled" [disabled]="signUpForm.invalid || disabled">
      Anfrage senden
      @if (!disabled) {
        <i nz-icon nzType="arrow-right"></i>
      }
    </button>
  </form>

  <div class="auth-card-footer">
    Sie haben bereits einen Account? <a routerLink="/login">Jetzt anmelden</a>
  </div>
</app-auth-shell>
